<template>
  <g>
    <circle cx="2" cy="2" r="2" fill="currentColor" />
    <circle cx="2" cy="10" r="2" fill="currentColor" />
    <circle cx="2" cy="18" r="2" fill="currentColor" />
  </g>
</template>